import React from "react";
import { Field, FieldInputProps, FieldMetaProps } from "formik";
import Select, { TOption, TOptionType, TSelectProps } from "./Select";

export type { TOption, TOptionType };

type TFormikSelectProps = {
  name: string;
  onChange?: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => void;
} & TSelectProps;
export default function FormikSelect({
  name,
  onChange,
  ...props
}: TFormikSelectProps) {
  return (
    <Field name={name}>
      {({
        field,
        meta,
      }: {
        field: FieldInputProps<string | number>;
        meta: FieldMetaProps<string>;
      }) => (
        <Select
          {...props}
          {...field}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          onChange={(event) => {
            field.onChange(event);
            if (onChange) {
              onChange(event);
            }
          }}
        />
      )}
    </Field>
  );
}
